// Module
var code = "<div class=\"ib-layout__line-spacing u-text-center\">\n    <h2 class=\"ib-heading ib-heading--title-box\">New Component ib-ui-fare-conditions</h2>\n</div>";
// Exports
module.exports = code;